
export function getPlatformInfo() {
    const ua = navigator.userAgent.toLowerCase();
    
    // 1. 优先检测移动设备
    if (/iphone|ipod/.test(ua)) {
        const match = ua.match(/os (\d+)_(\d+)_?(\d+)?/);
        return { os: 'ios', version: match ? match.slice(1).join('.') : 'unknown' };
    }
    
    // 2. 检测iPad（包括现代iPad伪装成Mac的情况）
    if (/ipad/.test(ua) || 
        ((/macintosh|mac os x/.test(ua)) && 'ontouchend' in document)) {
        const match = ua.match(/os (\d+)_(\d+)_?(\d+)?/);
        return { os: 'ios', version: match ? match.slice(1).join('.') : 'unknown' };
    }
    
    if (/android/.test(ua)) {
        const match = ua.match(/android (\d+\.\d+)/);
        return { os: 'Android', version: match ? match[1] : 'unknown' };
    }

    // 3. 然后尝试现代API（用于桌面平台检测）
    if ('userAgentData' in navigator) {
        // @ts-ignore (暂时忽略类型检查)
        const platform = navigator.userAgentData.platform.toLowerCase();
        if (platform.includes('macos')) return { os: 'MacOS', version: 'desktop' };
        if (platform.includes('windows')) return { os: 'Windows', version: 'desktop' };
        if (platform.includes('linux')) return { os: 'Linux', version: 'desktop' };
    }

    // 4. 传统userAgent检测（兼容所有浏览器）
    if (/macintosh|mac os x/.test(ua)) {
        return { os: 'MacOS', version: 'desktop' };
    }
    if (/windows/.test(ua)) {
        const match = ua.match(/windows nt (\d+\.\d+)/);
        return { os: 'Windows', version: match ? match[1] : 'unknown' };
    }
    if (/linux/.test(ua)) return { os: 'Linux', version: 'desktop' };

    return { os: 'unknown', version: 'unknown' };
}